import React from 'react';

import Summary from '../Summary';
import SummaryTrials from '../SummaryTrials';
import SummaryStudents from '../SummaryStudents';
import { useCheckoutContext } from '../../state/CheckoutContext';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

const SummaryContainer = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const { isTrial, isStudentPromotion } = checkoutEntityState;

  // render student summary if isStudentPromotion === true regardless of trial status
  if (isTrial && !isStudentPromotion) {
    return <SummaryTrials />;
  }
  if (isStudentPromotion) {
    return <SummaryStudents />;
  }
  return <Summary />;
};

export default SummaryContainer;
